import { useIntl } from "react-intl";

import { ReactComponent as EditIcon } from "assets/images/iconsV2/edit-02.svg";
import { ReactComponent as TrashIcon } from "assets/images/iconsV2/trash-01.svg";
import Button from "components/v2/Button/Button";
import { formatPaymentLocationLabel } from "./helpers";
import type { AccountMappingRow } from "./types";

interface AccountMappingRowViewProps {
  row: AccountMappingRow;
  showLabels: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export default function AccountMappingRowView({ row, showLabels, onEdit, onDelete }: AccountMappingRowViewProps) {
  const intl = useIntl();

  return (
    <>
      <div className="account-mapping-row-view">
        <div className="account-mapping-col-shipper">
          {showLabels && (
            <div className="text-sm font-medium account-mapping-view-label">
              {intl.formatMessage({ id: "settings.accountMapping.shipper", defaultMessage: "Shipper" })}
            </div>
          )}
          <div className="text-md account-mapping-view-value">{formatPaymentLocationLabel(row)}</div>
        </div>
        <div className="account-mapping-col-value">
          {showLabels && (
            <div className="text-sm font-medium account-mapping-view-label">
              {intl.formatMessage({ id: "settings.accountMapping.yourValue", defaultMessage: "Your value" })}
            </div>
          )}
          <div className="text-md account-mapping-view-value">{row.external_account_number}</div>
        </div>
      </div>
      <div className="account-mapping-row-actions">
        <Button
          testId="account-mapping-edit"
          variant="tertiary-gray"
          size="sm"
          aria-label={intl.formatMessage({ id: "general.edit", defaultMessage: "Edit" })}
          iconLeft={<EditIcon />}
          onClick={onEdit}
        />
        <Button
          testId="account-mapping-delete"
          variant="tertiary-gray"
          size="sm"
          aria-label={intl.formatMessage({ id: "general.delete", defaultMessage: "Delete" })}
          iconLeft={<TrashIcon />}
          onClick={onDelete}
        />
      </div>
    </>
  );
}
